var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKonference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H8C8.41 1.25 8.75 1.59 8.75 2C8.75 2.41 8.41 2.75 8 2.75H6.44C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V11.88C21.24 11.47 21.58 11.13 21.99 11.13C22.4 11.13 22.74 11.47 22.74 11.88V12.77C22.75 16.76 21.54 17.97 17.56 17.97Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C11.59 22.75 11.25 22.41 11.25 22V17.22C11.25 16.81 11.59 16.47 12 16.47C12.41 16.47 12.75 16.81 12.75 17.22V22C12.75 22.41 12.41 22.75 12 22.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 10.12H13.1C11.53 10.12 10.51 9.10001 10.51 7.53001V4.01001C10.51 2.49001 11.74 1.26001 13.26 1.26001H17.86C19.29 1.26001 20.45 2.42001 20.45 3.85001V7.53001C20.45 8.96001 19.29 10.12 17.86 10.12ZM13.26 2.76001C12.57 2.76001 12.01 3.32001 12.01 4.01001V7.53001C12.01 8.51001 12.63 8.62001 13.1 8.62001H17.86C18.46 8.62001 18.95 8.13001 18.95 7.53001V3.85001C18.95 3.25001 18.46 2.76001 17.86 2.76001H13.26Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 8.87001C21.13 8.87001 20.7999 8.76001 20.4799 8.53001L19.27 7.68001C19.07 7.54001 18.95 7.31001 18.95 7.07001V4.31001C18.95 4.07001 19.07 3.84001 19.27 3.70001L20.4799 2.85001C20.9999 2.48001 21.56 2.41001 22.02 2.65001C22.48 2.89001 22.74 3.39001 22.74 4.03001V7.36001C22.74 8.00001 22.48 8.50001 22.02 8.74001C21.85 8.83001 21.66 8.87001 21.45 8.87001ZM20.45 6.68001L21.25 7.24001V4.14001L20.45 4.70001V6.68001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonference);
export default __webpack_public_path__ + "static/media/konference.f4f3b7bb5b580cb38a9ce48b5f0110c3.svg";
export { ForwardRef as ReactComponent };